// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import siteMessage from "@insite/client-framework/SiteMessage";
import toolkitConstants from "@toolkit/constants";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";

export default mergeToNew(toolkitConstants, {
    /* Store Custom Code - Start */
    allowedPropertiesForUpdate: ["canSeePricesPolicy", "reportingRoles", "bunzl_AdditionalApprovers", "languageId"],
    cartHeaderLabels: {
        availability: "Availability",
    },
    productWarnings: {
        prop65: {
            warning: "ProductProp65Warning",
            none: "ProductProp65Warning_None",
        },
    },
    productListControllerContainerId: "productListControllerContainer",
    imageTypes: {
        sizeChart: "SizeChart",
        seriesBadges: "Logo",
    },
    /* Store Custom Code - End */
    formField: {
        borderWidth: 2,
        borderWidthFocus: 2,
        borderWidthError: 2,
    },
    defaultHeaderHeight: {
        mainHeight: 175,
        secondaryHeight: 32,
    },
    roundingRulesTypes: {
        multipleOnly: "Multiple Only",
    },
    cookieNames: {
        viewedCookiePolicy: "viewed_cookie_policy",
    },
    /* Store Custom Code - Start */
    userCannotSeePricesMessage: () => siteMessage("PriceOverride_UserCannotSeePrices") as string,
    excludedPagesTypes: [],
    inventoryNotAvailableMessage: "Inventory Not Available",
    attributeTypes: {
        BCHVendorSku: "ItemBCHVendorSku",
    },
    /* Store Custom Code - End */
    pageType: {
        blogPost: "BlogPage",
        blogHome: "BlogHomePage",
        blogList: "BlogListPage",
        issueTracker: "IssueTrackerPage",
    },
    widgetGroup: {
        blogList: "Blog List",
        blogPage: "Blog Page",
    },
    documentTypes: {
        videos: "videoLink",
    },
});
